export default "__VITE_ASSET__e41f6563__"